import { useTranslator } from "@eo-locale/react";

import { useRouter } from "next/router";
import { ReactNode, useState } from "react";

import { useAppSelector } from "@/redux/store/hooks";
import { HTMLWrapper } from "@/storybook-components";
import useUser from "@/hooks/useUser";
import Alerts from "@/components/alerts";

const AllAlert = () => {
  const { asPath } = useRouter();
  const { translate } = useTranslator();
  const { isUserAdmin, isRegisteredUserLoggedIn } = useUser();
  const { state: projectState, visibilityMode } = useAppSelector(
    (state) => state.project.project
  );
  const place = useAppSelector((state) => state?.place?.place);
  const { state: placesState, archivalReasonMessage } = place || {};
  const { googleTranslationEnabled } = useAppSelector(
    (state) => state.settings.settings
  );

  let alert = {} as {
    title?: string;
    description: string | ReactNode;
    status: "warning" | "success" | "error" | "info";
  };

  const isToolArchived = placesState === "archived";
  const isProjectArchived = projectState === "archived";
  const isToolPublished = placesState === "published";
  const isPanelled = visibilityMode === "Panelled";

  switch (Boolean(placesState)) {
    case isToolArchived || isProjectArchived:
      alert = {
        status: "info",
        description:
          archivalReasonMessage || translate("brainstormers.boardArchived")
      };
      break;
    case isToolPublished &&
      isPanelled &&
      isRegisteredUserLoggedIn &&
      !isUserAdmin:
      alert = {
        status: "info",
        description: translate("brainstormers.panelledListTitle")
      };
      break;
    case isToolPublished && isPanelled && !isRegisteredUserLoggedIn:
      alert = {
        status: "info",
        title: translate("brainstormers.panelledListTitle"),
        description: (
          <HTMLWrapper
            html={translate("brainstormers.panelledListDesc", {
              loginRoute: `/login?next=${encodeURIComponent(asPath)}`,
              target: "_parent"
            })}
          />
        )
      };
      break;
  }
  const [showAlert, setShowAlert] = useState(Object.keys(alert).length > 0);
  const { status, title, description } = alert;
  const topPosition = googleTranslationEnabled ? "16.75rem" : "13.75rem";
  const smTopPos = googleTranslationEnabled ? "6.68rem" : "4.68rem";
  return showAlert ? (
    <Alerts
      mb={12}
      title={title}
      status={status}
      description={description}
      onClose={() => setShowAlert(!showAlert)}
      zIndex={500}
      pos={"absolute"}
      top={{
        base: topPosition,
        lg: topPosition,
        md: topPosition,
        sm: smTopPos
      }}
      ml={"5.313rem"}
      mr={"1rem"}
      width={{ base: "62vw", lg: "62vw", md: "60vw", sm: "73vw" }}
      lineHeight={"1.2rem"}
    />
  ) : null;
};

export default AllAlert;
